import React from 'react'

import LtiApplyTheme from './LtiApplyTheme'
import LaunchRetriever from './LaunchRetriever'
import SpecialCharacters from "./SpecialCharacters";
import ContentItemForm from "./ContentItemForm";
import {Button} from "@instructure/ui-buttons";
import {Flex} from "@instructure/ui-flex";
import {Link} from "@instructure/ui-link";
import {Text} from "@instructure/ui-text";
import {IconQuestionLine} from "@instructure/ui-icons";
import {fromBase64} from "./base64";
import {NewsComponent} from "./NewsComponent.js";

const settings = {
  'https://localhost:3000': {
    'ltiServer': process.env.REACT_APP_LTI_URL
  },
  'https://characters.wyelearning.com': {
    'ltiServer': 'https://lti.wyelearning.com'
  }
}

class App extends React.Component {
  state = {
    jwt: null,
    needsToken: false,
    error: null,
    brandConfig: undefined,
    returnUrl: null,
    highContrast: false,
    data: null,
    css: undefined,
    development: process.env.NODE_ENV !== 'production',
    // The content items we are passing back
    contentItems: null,
    // Previously used items
    used: []
  }

  constructor(props) {
    super(props)
    const origin = window.origin
    if (settings[origin]) {
      this.server = settings[origin].ltiServer
    }
  }
  
  componentDidMount() {
    const used = this.loadUsed()
    this.setState({used})
  }

  cssVariableUrl = (data) => {
    // There isn't a variable for the css URL but the json url is in the same place.
    const jsonUrl = data.custom_brand_config[0]
    if (jsonUrl && jsonUrl.endsWith(".json")) {
      return jsonUrl.slice(0, -5) + ".css"
    }

  }

  updateData = async (data) => {
    let selection = data.custom_selection[0]
    // If there isn't any selection is sends through the unexpanded variable (although this seems to have changed)
    if (selection === '$com.instructure.Editor.selection' || selection === '') {
      selection = undefined
    }

    const customCharacters = data.custom_characters && data.custom_characters[0];
    return this.setState({
      brandConfig: data.custom_brand_config[0],
      highContrast: data.custom_high_contrast[0] === 'true',
      selection: selection,
      returnUrl: data.content_item_return_url[0],
      data: data.data[0],
      css: data.custom_canvas_css[0],
      cssVariables: this.cssVariableUrl(data),
      // if there's a development custom variable or we're in development mode.
      development: data.custom_development || this.state.development,
      // If there are custom characters
      characters: this.parseCharacters(customCharacters)
    })
  }
  
  parseCharacters = (source) => {
    if (source && source.length > 0) {
      try {
        const str = fromBase64(source)
        return JSON.parse(str)
      } catch (error) {
        console.log("Failed to decode: "+ source + " reason "+ error)
      }
    }
  }

  makeContentItem = (html) => {
    // Don't return anything if empty
    let item = []
    if (html.length > 0) {
      item.push({
        '@type': 'ContentItem',
        'mediaType': 'text/html',
        'text': html,
        'placementAdvice': {
          'presentationDocumentTarget': 'embed'
        }
      })
    }
    return {
      '@context': 'http://purl.imsglobal.org/ctx/lti/v1/ContentItem',
      '@graph': item
    }
  }
  
  handleCharacter = (item) => {
    // When previewing there won't be a return URL.
    if(this.state.returnUrl) {
      const updatedUsed =[item, ...this.state.used]
          // Find first position in array and if it matches position of current element keep it.
          // This is slow but simple and as we only have 10 elements it doesn't matter
          .filter((item, pos, self) => self.findIndex(el => el.character === item.character) === pos)
              .slice(0, 10)
      this.saveUsed(updatedUsed)
      this.setState(
          {contentItems: JSON.stringify(this.makeContentItem(item.character))},
          () => this.form && this.form.submit()
      )
    }
  }
  
  handleCancel = () => {
    if(this.state.returnUrl) {
      this.setState(
          {contentItems: JSON.stringify(this.makeContentItem(""))},
          () => this.form && this.form.submit()
      )
    }
  }
  
  handleRef = (ref) => {
    this.form = ref
  }
  
  loadUsed = () => {
    try {
      const used = localStorage.getItem('used');
      if (used) {
        const items = JSON.parse(used);
        if (Array.isArray(items)) {
          return items;
        }
      }
    } catch (e) {
      console.info(`Failed to load used: ${e}`)
    }
    return []
  }
  
  saveUsed = (items) => {
    try {
      const used = JSON.stringify(items)
      localStorage.setItem('used', used)
    } catch (e) {
      console.info(`Failed to save used: ${e}`)
    }
  }

  render() {
    const usedCharacters = this.state.used.length > 0 ? {
      title: 'Last Used',
      characters: this.state.used
    } : null
    return (
        <LaunchRetriever ltiServer={this.server} handleData={this.updateData}>
          <LtiApplyTheme url={this.state.brandConfig} highContrast={this.state.highContrast}>
            <Flex direction='column' height='100%'>
              <Flex.Item shouldGrow shouldShrink>
                <SpecialCharacters onCharacter={this.handleCharacter} characters={this.state.characters}
                                   used={usedCharacters}/>
              </Flex.Item>
              <Flex.Item>
                <Flex padding='small'>
                  <Flex.Item>
                    <Link renderIcon={IconQuestionLine} margin='0 medium' target='_blank'
                          href='https://wyelearning.com/support/characters/'>Help</Link>
                  </Flex.Item>
                  <Flex.Item>
                    <Link href='https://wyelearning.com' target='_blank' isWithinText={false}>
                      <Text size='small'>by Wye Learning</Text>
                    </Link>
                  </Flex.Item>
                  <Flex.Item>
                    <NewsComponent/>
                  </Flex.Item>
                  <Flex.Item shouldGrow/>
                  <Flex.Item>
                    <Button onClick={this.handleCancel}>Cancel</Button>
                  </Flex.Item>
                </Flex>
              </Flex.Item>
            </Flex>
            <ContentItemForm data={this.state.data} elementRef={this.handleRef} returnUrl={this.state.returnUrl}
                             contentItems={this.state.contentItems}/>
          </LtiApplyTheme>
        </LaunchRetriever>
    )
  }
}

export default App
